<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <h1>Tham gia cuối kỳ</h1>
                    <p>※ Lưu ý: Nếu đang làm trên thiết bị này, mà thoát ra làm trên thiết bị khác thì câu hỏi sẽ không được lưu, và phải làm lại từ đầu.</p>
                </div>
                <div><img src="/static\images\vi\newManual\finalExamManual-1.png" alt="" /></div>
                <div>
                    <p>① Nhấn vào nút [Bài thi cuối kỳ] để tham giam thi cuối kỳ.</p>
                </div>
                <div><img src="/static\images\vi\newManual\exam_final_new_1.png" alt="" /></div>
                <div>
                    <p>Sau khi nhấn nút [Thi cuối kỳ], màn hình như bên dưới sẽ được hiển thị.</p>
                    <p>※ Tại đây bạn cũng có thể chọn loại hiển thị toàn bộ câu hỏi hoặc từng câu trong bài thi.</p>
                    <p>② Nhấn nút [Bắt đầu kiểm tra] để thực hiện bài thi.</p>
                </div>
                <div><img src="/static\images\vi\newManual\edit_exam_final_2.png" alt="" /></div>
                <div>
                    <p>③ Chọn đáp án đúng vào câu hỏi bạn cần trả lời.</p>
                    <p>④ Nhấn vào nút [Cần xem lại] nếu bạn chưa chắc chắn với câu hỏi này.</p>
                    <p>⑤ Hiển thị danh sách câu hỏi. </p>
                    <p>&nbsp;&nbsp;&nbsp; Câu đang có viền màu đỏ là câu hiện tại bạn đang làm.</p>
                    <p>&nbsp;&nbsp;&nbsp; Câu được tô màu xanh là những câu bạn đã điền đáp án.</p>
                    <p>⑥ Hiển thị danh sách những câu bạn cần xem lại.</p>
                    <p>⑦ Nhấn nút nộp bài sẽ hiện thông báo nộp bài thi.</p>
                    <p>⑧ Nút hiển thị từng câu khi nhấn vào sẽ chuyển sang trạng thái hiển thị từng câu cho bạn.</p>
                </div>
                <div><img src="/static\images\vi\newManual\edit_exam_final3.png" alt="" /></div>
                <div>
                    <p>Sau khi nhấn nút nộp bài thì màn hình thông báo sẽ xuất hiện để xác nhận bạn có chắc chắn muốn nộp bài hay không. Và hiển thị số câu trả lời của bạn.</p>
                    <p>Trong ví dụ dưới đây:</p>
                    <p>Số câu trả lời: 1/5</p>
                    <p>Tức là học viên chỉ mới trả lời được 1 câu trên 5 số câu hỏi của bài thi.</p>
                    <p>⑨ Nhấn nút [Ok] để nộp bài.</p>
                    <p>※ Nếu chưa muốn nộp bài, có thế nhấn dấu [X] hoặc nút [Huỷ] để quay lại màn hình làm bài.</p>
                    <p>※ Nếu hết thời gian làm bài mà vẫn chưa nhấn nút [Nộp bài], thì hệ thống sẽ tự động nộp bài.</p>
                </div>
                <div><img src="/static\images\vi\newManual\edit_exam_final4.png" alt="" /></div>
                <div>
                    <p>Sau khi khi nhấn nộp bài sẽ hiển thị màn hình thông báo kết quả.</p>
                    <p>⑩ Nhấn nút [Chi tiết câu sai] để hiển thị danh sách những câu sai bạn đã làm</p>
                    <p>⑪ Nhấn nút [Xác nhận] để quay lại màn hình mục lục</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>① Nhấn vào biểu tượng thi cuối kì.</p></div>
                <div><p>※ Trường hợp bạn chưa học xong nội dung bài học và làm bài tập chưa đạt tỉ lệ điểm đậu (Icon quyển sách dưới nội dung sẽ màu đỏ hoặc đen) thì khi nhấn vào bài thi cuối kì sẽ không thi được bài thi cuối kì xuất hiện một thông báo.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\final_test_1_1.png" alt="" /></div>
                <div><img src="/static\images\vi\newManual\mobile\final_test_1_2.png" alt="" /></div>
                <div><p>※ Trường hợp bạn học xong nội dung bài học và làm bài tập đạt tỉ lệ điểm đậu (Icon quyển sách dưới nội dung đều là màu xanh) thì khi nhấn vào bài thi cuối kì sẽ chuyển qua màn hình thông báo thi cuối kì.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\final_test_1_3.png" alt="" /></div>
                <div><p>② Nhấn button [Bắt đầu kiểm tra], thì Kì thi cuối kỳ sẽ bắt đầu. Khi nhấn button [Hủy], thì sẽ quay trở lại màn hình Danh sách khóa học.</p></div>
                <div><p>※ Có thể làm bài kiểm tra cuối kỳ bao nhiêu lần cũng được. Việc phán đoán Đậu/Không đậu sẽ dựa vào thành tích cuối cùng.</p></div>
                <div><p>● Loại hiển thị: Hiển thị toàn bộ câu hỏi hoặc chỉ hiển thị từng câu.</p></div>
                <div><p>● Số lần dự thi: Tổng số lần dự thi của bạn.</p></div>
                <div><p>● Điểm số cuối cùng: số điểm cuối cùng của bạn thi được.</p></div>
                <div><p>● Điểm cao nhất: Điểm số cao nhất trong các lần thi.</p></div>
                <div><img src="/static\images\vi\newManual\mobile\edit_exam_final_mb_1.png" alt="" /></div>
                <div>
                    <p>③ Nhấn vào nút [Danh sách] hiển thị danh sách câu hỏi và danh sách kiểm tra lại.</p>
                    <p>● Câu đang có viền màu đỏ là câu hiện tại bạn đang làm.</p>
                    <p>● Câu được tô màu xanh là những câu bạn đã điền đáp án.</p>
                    <p>● Khi nhấn vào câu hỏi sẽ di đến câu hỏi bạn vừa chọn.</p>
                    <p>④ Nhấn nút nộp bài sẽ hiện thông báo nộp bài thi.</p>
                    <p>⑤ Chọn đáp án đúng vào câu hỏi bạn cần trả lời.</p>
                    <p>⑥ Hiển thị danh sách những câu bạn cần xem lại.</p>
                    <p>⑦ Có thể chuyển đổi câu hỏi bằng biểu tượng [Về trước] hoặc [Đi tiếp] và có chuyển đổi kiểu hiển thị từng câu với nút [Hiển thi từng câu]</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\edit_exam_final_mb_2.png" alt="" /></div>
                <div>
                    <p>Sau khi nhấn nút nộp bài thì màn hình thông báo sẽ xuất hiện để xác nhận bạn có chắc chắn muốn nộp bài hay không. Và hiển thị số câu trả lời của bạn.</p>
                    <p>Trong ví dụ dưới đây:</p>
                    <p>Số câu trả lời: 1/5</p>
                    <p>Tức là học viên chỉ mới trả lời được 1 câu trên 5 số câu hỏi của bài thi.</p>
                    <p>⑨ Nhấn nút [Ok] để nộp bài.</p>
                    <p>※ Nếu chưa muốn nộp bài, có thế nhấn dấu [X] hoặc nút [Huỷ] để quay lại màn hình làm bài.</p>
                    <p>※ Nếu hết thời gian làm bài mà vẫn chưa nhấn nút [Nộp bài], thì hệ thống sẽ tự động nộp bài.</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\edit_exam_final_mb_3.png" alt="" /></div>
                <div>
                    <p>Sau khi khi nhấn nộp bài sẽ hiển thị màn hình thông báo kết quả.</p>
                    <p>⑩ Nhấn nút [Chi tiết câu sai] để hiển thị danh sách những câu sai bạn đã làm</p>
                    <p>⑪ Nhấn nút [Xác nhận] để quay lại màn hình mục lục</p>
                </div>
                <div><img src="/static\images\vi\newManual\mobile\edit_exam_final_mb_4.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/vi/finalExam_manual.vue